import React from 'react';
import NotificationsArea from "./NotificationsArea";
import './HeroArea.css';

const HeroArea = () => {
  return (
    <div className="main-slider-wrapper">
      <div className="main-searchbar-area">
        <div className="container">
          <NotificationsArea />
        </div>
      </div>
    </div>
  );
};

export default HeroArea;

